export default "__VITE_ASSET__aa2a11a2__"